import { createApiClient } from "@jbnl/api-client";

/** One client per SPA. The base URL is always the relative `/api`. */
export const api = createApiClient();
